import { GetListParams, SortInterface } from '@core/interfaces/get-list.interface';
import { LocationFilter } from '@core/interfaces/time-window.interface';
import { OffsetPagination } from '@core/interfaces/pagination-params.interface';
import { ProductFilter } from '@core/interfaces/nomenclature-balances';

export class GetListNomenclatureBalance {
  static readonly type = '[GetListNomenclatureBalance] Get List Nomenclature Balance';

  constructor(public params: GetListParams<LocationFilter>) {}
}

export class GetRemaining {
  static readonly type = '[Get Remaining] Get Remaining';

  constructor(
    public readonly article: number,
    public readonly pharmacyId: number,
  ) {}
}

export class SetProductFilter {
  static readonly type = '[SetProductFilter] Set Product Filter';

  constructor(public filter: ProductFilter) {}
}

export class SetProductPaginationParams {
  static readonly type = '[SetProductPaginationParams] Set Product Pagination Params';

  constructor(public paginationParams: OffsetPagination) {}
}

export class SetProductSort {
  static readonly type = '[SetProductSort] Set Product Sort';

  constructor(public sort: SortInterface) {}
}
